import React from 'react'
import {Header, Container, Icon, Button, Divider} from 'semantic-ui-react'
import SidebarComponent from '../layout/SidebarComponent'
import { getSortStatusName } from '../glossary/options'
import styles from '../glossary/sidebar.module.scss'
import useSWR  from 'swr'
import classNames from 'classnames'
import {AppFetcher} from "../../fetch/application"
import {statusOptions, fieldNames} from "./options"

let dataFlows = [];
let dataContent = [];
let dataCreation = [];

const SidebarPanel = ({ visible, item, close, edit, handleDialogVisibility, handleFlowVisibility, openDialogCreation, apps }) => {

    //console.log("item", item)
    const periods = [
        {
            text:'Daily',
            value: 'daily'
        },
        {
            text:'Intraday',
            value: 'intraday'
        },
        {
            text:'Monthly',
            value: 'monthly'
        },
        {
            text:'Real time',
            value: 'real-time'
        },
        {
            text:'Weekly',
            value: 'weekly'
        }
    ]
    const statuses = [
        {
            text:'New',
            value: 'new'
        },
        {
            text:'Alleged against source',
            value: 'alleged-against-source'
        },
        {
            text:'Alleged against target',
            value: 'alleged-against-target'
        },
        {
            text:'Confirmed',
            value: 'confirmed'
        },
        {
            text:'Challenge source',
            value: 'challenge-source'
        },
        {
            text:'Challenge target',
            value: 'challenge-target'
        },
        {
            text:'Rescinded',
            value: 'rescinded'
        }
    ]
    const types = [
        {
            text:'Adjustment',
            value: 'adjustment'
        },
        {
            text:'Derivation',
            value: 'derivation'
        },
        {
            text:'Enrichment',
            value: 'enrichment'
        },
        {
            text:'Manual entry',
            value: 'manual-entry'
        }
    ]
    const loadElements = React.useRef(true)
    const { data : flowList, errorFlows } = useSWR(((item === null)) ? null : `/data-flow/list/${item.id}`, AppFetcher, { errorRetryCount: 2 })
    if(flowList && flowList.data && loadElements.current) {
        let tmp_flows = [];
        flowList.data.map( object => {
            let tmp_source = apps.filter(a => a.id === object.sourceApplicationId)[0];
            let tmp_target = apps.filter(a => a.id === object.targetApplicationId)[0];
            tmp_flows.push({
                id: object.id,
                source: tmp_source && tmp_source.name,
                target: tmp_target && tmp_target.name,
                periodicity: periods.filter( i => i.value === object.periodicity )[0].text,
                status: statuses.filter( i => i.value === object.status )[0].text,
            })
        })
        dataFlows = tmp_flows;
    }
    const { data : contentList, errorContent } = useSWR(((item === null)) ? null : `/data-content/list/${item.id}`, AppFetcher, { errorRetryCount: 2 })
    if(contentList && contentList.data === null) {
        dataContent = []
    }
    else if(contentList && contentList.data && loadElements.current) {
        let tmp_content = [];
        contentList.data.map( object => {
            if(object.type === "application") {
                let tmp = object;
                tmp.statusForView = statusOptions.filter(i => i.value === object.status)[0] && statusOptions.filter(i => i.value === object.status)[0].text
                tmp_content.push(tmp)
            }
        })
        dataContent = tmp_content;
    }
    const { data : creationList, errorCreation } = useSWR(((item === null)) ? null : `/data-creation/list/${item.id}`, AppFetcher, { errorRetryCount: 2 })
    if(creationList && creationList.data === null) {
        dataCreation = []
    }
    else if(creationList && creationList.data && loadElements.current) {
        let tmp_creation = [];
        creationList.data.map( object => {
            tmp_creation.push({
                id: object.id,
                description: object.description,
                docLink: object.docLink,
                status: statusOptions.filter( i => i.value === object.status )[0].text,
                type: types.filter( i => i.value === object.type )[0].text,
            })
        })
        dataCreation = tmp_creation;
    }

    const openDialogFC = (df) => {
        const tmp = flowList.data.filter(i => i.id === df.id)[0]
        //openDialogFlowContent(tmp, true);
        handleDialogVisibility(null, true, tmp);
    }

    const editContent = (content, isFlow, flow) => {
        handleDialogVisibility(content, isFlow, flow)
    }

    const editCreation = (content, creation) => {
        openDialogCreation(content, creation)
    }

    const editFlow = (flow) => {
        handleFlowVisibility(flow)
    }

    const addCreation = (c) => {
        openDialogCreation(c)
    }

    let date = '';
    if(item.lastAttestedAt) {
        let tmp = new Date(item.lastAttestedAt)
        date = tmp.toLocaleDateString()
    }

    return (
        <SidebarComponent visible={visible}>
            <Container as="div" className={styles.containerMenu}>
                <Icon name="pencil"  onClick={edit} className={styles.pointer}/>
                &nbsp;
                <Icon name="close" onClick={close} className={styles.pointer}/>
            </Container>

            <Header as="h3" className={styles.marginB30}>
                Details
            </Header>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.name.toUpperCase()}</p>
                <p className={styles.pStrong}>{item.name}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.firmReference.toUpperCase()}</p>
                <p>{item.firmReference}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.businessArea.toUpperCase()}</p>
                <p>{item.businessArea}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.type.toUpperCase()}</p>
                <p>{item.type}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.vendor.toUpperCase()}</p>
                <p>{item.vendor}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.docLink.toUpperCase()}</p>
                <p>{item.docLink}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>{fieldNames.status.toUpperCase()}</p>
                <p>{getSortStatusName(item.status)}</p>
            </div>

            <div className={styles.marginB30}>
                <p className={styles.pH}>LAST ATTESTED</p>
                <p>{item.user ? item.user.firstName + "" + item.user.lastName + (date ? ", " : "") : ''} {date ? date : ''}</p>
            </div>

            {
                dataContent && dataContent.length > 0 &&
                <div>
                    <Divider horizontal>Data Content</Divider>
                    {dataContent.map((c, ind) => {
                        return <div className={styles.marginB10} key={ind} style={{float: "left", width: "100%"}}>
                            <div style={{float: "left", width: "calc(100% - 40px)", cursor: "pointer"}}
                                    onClick={(e) => editContent(c, false, null)}>
                                <span>{c.name}</span>
                                <br/>
                                <span style={{fontSize: "12px", marginLeft: "20px"}}>{c.statusForView}</span>
                            </div>
                            {!c.dataCreationId && <Button onClick={() => addCreation(c)} title={"Add new Data Creation"} style={{float: "right", padding: "6px"}}>
                                <Icon style={{margin: '0px'}} name="plus" />
                            </Button>}
                            {c.dataCreationId && dataCreation && dataCreation.length > 0 &&
                                <div>
                                    {dataCreation.map((creation, ind) => {
                                        if(c.dataCreationId === creation.id){
                                            return <div
                                                style={{marginLeft: "40px", marginTop: "6px", float: "left", width: "calc(100% - 42px)"}}
                                                className={classNames(styles.marginB10, styles.pointer)}
                                                key={ind}
                                                onClick={() => editCreation(c, creation)}>
                                                <span>{creation.description}</span>
                                                <br/>
                                                <span style={{fontSize: "12px", marginLeft: "20px"}}>{creation.type}, {creation.docLink}, {creation.status}</span>
                                            </div>
                                        }
                                    })}
                                </div>}
                        </div>
                    })}
                </div>
            }
            <div>
                <Button onClick={()=> handleDialogVisibility(null, false) }>
                    <Icon style={{marginRight: '10px'}} name="plus" />
                    Add new Data Content
                </Button>
            </div>

            {
                dataFlows && dataFlows.length > 0 &&
                    <div>
                        <Divider horizontal>Data Flows</Divider>
                        {dataFlows.map((i, index) => {
                            return <div  className={styles.marginB10} key={index} style={{float: "left", width: "100%"}}>
                                <div onClick={(e) => editFlow(i)} style={{float: "left", width: "calc(100% - 42px)", cursor: "pointer"}}>
                                    <span>{i.source} -> {i.target} </span>
                                    <br/>
                                    <span style={{fontSize: "12px", marginLeft: "20px"}}>{i.periodicity}, {i.status} </span>
                                </div>
                                {(i.target === item.name) &&
                                <Button onClick={() => openDialogFC(i) } title={"Add new Data Flow Content"} style={{float: "right", padding: "6px"}}>
                                    <Icon style={{margin: '0px'}} name="plus" />
                                </Button>}
                                { contentList && contentList.data && contentList.data.length > 0 &&
                                    <div>
                                        {contentList.data.map((c, ci) => {
                                        return (c.type === "data-flow" && c.dataFlowId === i.id) &&
                                            <div
                                                key={ci}
                                                style={{marginLeft: "40px", marginTop: "6px", float: "left", width: "calc(100% - 40px)", cursor: "pointer"}}
                                                onClick={(e) => editContent(c, true, i)}>
                                            {c.name}
                                            </div>
                                    })}
                                    </div>
                                }
                                <div style={{clear: "both", height: "12px"}}> </div>
                            </div>
                        })}
                    </div>
            }
            <div>
                <Button onClick={ handleFlowVisibility }>
                    <Icon style={{marginRight: '10px'}} name="plus" />
                    Add new Data Flow
                </Button>
            </div>

        </SidebarComponent>

    )
}

export default SidebarPanel